// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1D7eo","title":"AfterFrontImage_title__3Hlv8"};